import React from "react"

import { Container, SearchIcon, Actions, ResetSearch, InfoIcon } from "./Search.styled"

import { Loader } from "./Loader"
import Input from "./Form/Input"
import { Tooltip } from "./Tooltip"

type Props = {
  handleOnChange: (input: string) => void
  placeholder?: string
  loading?: boolean
  defaultValue?: string
  inSideBar?: boolean
  padding?: string
  searchInfoContent?: string
}

const Search = ({
  handleOnChange,
  placeholder,
  loading,
  defaultValue,
  inSideBar,
  padding = "2rem",
  searchInfoContent,
  ...props
}: Props) => (
  <Container $inSidebar={inSideBar} $padding={padding} {...props}>
    <SearchIcon />
    <Input
      name={"search"}
      onChange={(e: React.FormEvent<HTMLInputElement>) => {
        handleOnChange(e.currentTarget.value.replace(/\//g, ""))
      }}
      placeholder={placeholder || "Search..."}
      value={defaultValue}
    />
    <Actions>
      {loading ? (
        <Loader color="black" />
      ) : (
        <ResetSearch $show={defaultValue !== ""} onClick={() => handleOnChange("")} />
      )}
      {searchInfoContent && (
        <>
          <InfoIcon
            data-tooltip-id="search-info-tooltip"
            data-tooltip-html={searchInfoContent}
          />
          <Tooltip id="search-info-tooltip" place="bottom" />
        </>
      )}
    </Actions>
  </Container>
)

export default Search
